export const SET_FCT_STATE = 'SET_FCT_STATE'
export const SET_FCT_SCREEN_STATE = 'SET_FCT_SCREEN_STATE'
export const SET_FCT_MESSAGES = 'SET_FCT_MESSAGES'
export const SET_FCT_STATIC_DOCUMENTS = 'SET_FCT_STATIC_DOCUMENTS'
